import{a as n}from"./chunk-RAAYCPUM.js";function m(...a){return n(o,a,p)}var o=(a,e)=>a.map(e),p=a=>(e,t,r)=>({done:!1,hasNext:!0,next:a(e,t,r)});export{m as a};
